/* eBay-Reviews — lädt Badge (percent/score) + Kommentare vom Lambda-Endpoint.
   Portiert aus industrialresell-astro/public/js/main.js (initEbaySlider/loadReviews),
   ergänzt um sessionStorage-Cache. Siehe AWS-REVIEWS-INTEGRATION.md.
   Response: { score:Number, percent:Number, comments:[{text,user,item}] } (max 12). */
(function () {
  var API_URL = 'https://zldqye254iajfkhebpambimrs40vwshq.lambda-url.us-east-1.on.aws/';
  var API_TIMEOUT = 6000;
  var CACHE_KEY = 'ebayReviews.v1';
  var CACHE_TTL = 6 * 60 * 60 * 1000; // 6 h

  /* Nur Fallback, falls API nicht erreichbar/leer. */
  var REVIEWS_FALLBACK = [
    { text: 'Alles bestens gelaufen, sehr zu empfehlen', buyer: 'seraildesultan', item: '' },
    { text: 'Artikel wie beschrieben, schneller Versand', buyer: 'bos-aussstatter', item: '' },
    { text: 'Alles super wie immer, sehr guter und netter Geschäftspartner.', buyer: 'more4youtechnik-gmbh', item: '' },
    { text: 'Thank You for this professional business! +++++', buyer: 'ihsnet', item: '' },
    { text: 'Kompetenter Service — besten Dank für die sehr gute Beratung.', buyer: 'Jasko', item: '' },
    { text: 'Exactly as described. Well packaged, arrived on time.', buyer: 'yachtdevicesus', item: '' }
  ];

  function escapeHtml(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var track = document.getElementById('ebay-track');
  var dotsWrap = document.getElementById('ebay-dots');
  var prevBtn = document.getElementById('ebay-prev');
  var nextBtn = document.getElementById('ebay-next');
  if (!track || !dotsWrap || !prevBtn || !nextBtn) return;

  var EBAY_LOGO = '<span class="ebay-reviews__card-logo" aria-hidden="true">'
    + '<span style="color:#E53238">e</span><span style="color:#0064D2">B</span>'
    + '<span style="color:#F5AF02">a</span><span style="color:#86B817">y</span></span>';

  var REVIEWS = REVIEWS_FALLBACK, currentIndex = 0, autoTimer = null, dots = [], lastCPV = null;
  function cardsPerView() { return window.innerWidth < 750 ? 1 : 3; }

  function createCard(r) {
    var el = document.createElement('div');
    el.className = 'ebay-reviews__card';
    var item = r.item ? '<span class="ebay-reviews__card-item">' + escapeHtml(r.item) + '</span>' : '';
    el.innerHTML =
      '<div class="ebay-reviews__card-head">' + EBAY_LOGO
        + '<span class="ebay-reviews__card-stars" aria-hidden="true">★★★★★</span></div>'
      + '<p class="ebay-reviews__card-text">„' + escapeHtml(r.text) + '"</p>'
      + '<div class="ebay-reviews__card-meta">'
        + '<strong class="ebay-reviews__card-buyer">' + escapeHtml(r.buyer) + '</strong>' + item + '</div>';
    return el;
  }

  function build() {
    var cpv = cardsPerView();
    if (cpv === lastCPV) return;
    lastCPV = cpv;
    var total = Math.ceil(REVIEWS.length / cpv);
    currentIndex = 0;
    track.innerHTML = '';
    dotsWrap.innerHTML = '';
    dots = [];
    for (var s = 0; s < total; s++) {
      var slide = document.createElement('div');
      slide.className = 'ebay-reviews__slide';
      for (var c = s * cpv; c < Math.min(s * cpv + cpv, REVIEWS.length); c++) {
        slide.appendChild(createCard(REVIEWS[c]));
      }
      track.appendChild(slide);
    }
    for (var d = 0; d < total; d++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ebay-reviews__dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Bewertung ' + (d + 1) + ' von ' + total);
      (function (i) { dot.addEventListener('click', function () { goTo(i); resetAuto(); }); })(d);
      dots.push(dot);
      dotsWrap.appendChild(dot);
    }
    goTo(0);
  }

  function goTo(n) {
    var t = dots.length;
    if (!t) return;
    currentIndex = ((n % t) + t) % t;
    track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    dots.forEach(function (dot, i) {
      var active = i === currentIndex;
      dot.classList.toggle('active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function resetAuto() {
    if (autoTimer) clearInterval(autoTimer);
    autoTimer = setInterval(function () { goTo(currentIndex + 1); }, 4000);
  }

  prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); resetAuto(); });
  nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); resetAuto(); });

  var rd;
  window.addEventListener('resize', function () {
    clearTimeout(rd);
    rd = setTimeout(function () { lastCPV = null; build(); resetAuto(); }, 250);
  });

  function applyBadge(data) {
    if (data && data.score != null) {
      var c = document.querySelectorAll('.ebay-review-count');
      for (var i = 0; i < c.length; i++) c[i].textContent = String(data.score);
    }
    if (data && data.percent != null) {
      var pct = Number(data.percent);
      if (!isNaN(pct)) {
        var txt = (pct % 1 === 0) ? String(pct) : pct.toFixed(1);
        var p = document.querySelectorAll('.ebay-review-percent');
        for (var j = 0; j < p.length; j++) p[j].textContent = txt;
      }
    }
  }

  function start(reviews) {
    REVIEWS = (reviews && reviews.length) ? reviews : REVIEWS_FALLBACK;
    lastCPV = null;
    build();
    resetAuto();
  }

  function mapComments(data) {
    // Alle echten Bewertungen zeigen (Duplikate erlaubt). Lambda liefert die aktuellsten max. 12.
    var arr = (data && Array.isArray(data.comments)) ? data.comments : [];
    return arr.filter(function (c) { return c && c.text; })
      .slice(0, 12)
      .map(function (c) { return { text: c.text, buyer: c.user || '', item: c.item || '' }; });
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || (Date.now() - o.t) > CACHE_TTL) return null;
      return o.d;
    } catch (e) { return null; }
  }
  function writeCache(d) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
  }

  /* Cache-Hit → kein Netzwerk-Call. */
  var cached = readCache();
  if (cached) {
    applyBadge(cached);
    start(mapComments(cached));
    return;
  }

  var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
  var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, API_TIMEOUT);
  fetch(API_URL, ctrl ? { signal: ctrl.signal } : undefined)
    .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
    .then(function (data) {
      clearTimeout(timer);
      writeCache(data);
      applyBadge(data);
      var m = mapComments(data);
      start(m.length ? m : REVIEWS_FALLBACK);
    })
    .catch(function () { clearTimeout(timer); start(REVIEWS_FALLBACK); });
})();
